import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42c67e1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("欢迎使用鹿小岚教务管理系统")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "point" }, null, -1))
const _hoisted_4 = { class: "user" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("灯塔指挥室")
const _hoisted_6 = { class: "avatar" }

import { Right,WarningFilled } from "@element-plus/icons-vue";
import { reactive, toRefs, ref } from "vue";
import { useRouter } from "vue-router";
import { logout } from "../config/interface";
import { ElMessage } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userName = ref("");
const state = reactive({
  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
});
const { circleUrl } = toRefs(state);
const router = useRouter();
const handleLogOut = () => {
  logout({}).then((response) => {
    const res: any = response.data;
    if (res.errorCode === 200) {
      localStorage.setItem("ACCESS_TOKEN", "");
      router.push({ path: "/login" });
    } else {
      ElMessage.error(res.data);
    }
  });
};
const toMessage = () => {
	router.push({
		path: '/message'
	})
}
const goManage = () => {
  window.open("https://manage.yoyolooming.com/#/");
};
if (localStorage.getItem("ACCESS_TOKEN")) {
  userName.value = JSON.parse(
    String(localStorage.getItem("ACCESS_TOKEN"))
  ).account;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "tit"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "tip",
      onClick: toMessage
    }, [
      _createVNode(_component_el_icon, { style: {"font-size":"28px"} }, {
        default: _withCtx(() => [
          _createVNode(_unref(WarningFilled))
        ]),
        _: 1
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_link, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goManage()))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_component_el_avatar, {
          size: 28,
          src: _unref(circleUrl)
        }, null, 8, ["src"]),
        _createTextVNode(" " + _toDisplayString(userName.value), 1)
      ]),
      _createVNode(_component_el_button, {
        type: "success",
        icon: _unref(Right),
        circle: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleLogOut()))
      }, null, 8, ["icon"])
    ])
  ]))
}
}

})